import React from 'react';

import { Button } from 'ui/component';
import classNames from './EABDJourneyInfoDialog.module.scss';

export interface JourneyInfoDialogProps
  extends Readonly<{
    isVisible: boolean;
    onClosePress: () => void;
  }> {}

export const JourneyInfoDialog = React.memo<JourneyInfoDialogProps>((props) => {
  const { isVisible, onClosePress } = props;

  if (!isVisible) {
    return null;
  }

  return (
    <div className={classNames.container}>
      <div className={classNames.header}>
        <p className={classNames.text}>{'Navigate with the arrows to see the end-to-end journey'}</p>
      </div>
      <div className={classNames.buttons}>
        <Button useLargerFontSize={true} onPress={onClosePress}>
          {'Got it'}
        </Button>
      </div>
    </div>
  );
});
